export { default } from 'common/models/document';
